import { TURN_BASED_DASHBOARD_CONTROLS_STYLES } from './turnBasedDashboardControlsStyles';
import { TURN_BASED_DASHBOARD_SHELL_STYLES } from './turnBasedDashboardShellStyles';

export const TURN_BASED_DASHBOARD_PAGE_STYLES = {
  ...TURN_BASED_DASHBOARD_SHELL_STYLES,
  ...TURN_BASED_DASHBOARD_CONTROLS_STYLES,
};
